<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Profile|Compact Task Form') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'Profile|The compact task form shows only essential fields when creating new tasks, making task creation faster and simpler.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Compact Form Fields') }}</h4>
            <p>
              {{
                s__(
                  'Profile|When enabled, the task creation form displays only the most important fields: Title, Assignee, and Due date. Priority is also shown if it is required at the project level. All other fields are hidden by default.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Full Form') }}</h4>
            <p>
              {{
                s__(
                  'Profile|When disabled, the full task form shows all available fields including description, priority, labels, and other options. This gives you more control over task details from the start.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|When to Use') }}</h4>
            <p>
              {{
                s__(
                  'Profile|Use compact form for quick task creation when you only need basic information. Use full form when you want to set all task details immediately during creation.'
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Profile|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}
</style>
